import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import moment from 'moment';

import { primary_s26_l96 } from '../../shared/lib/colors';

import { loadCategories } from '../../../redux/modules/categories';
import { loadTags } from '../../../redux/modules/tags';
import { loadCart } from '../../../redux/modules/cart';
import { loadUser } from '../../../redux/modules/user';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import Header from '../../shared/Header/Header';
import Footer from '../../shared/Footer/Footer';

import '../../../styles/style.scss';
import '../../../styles/style.less';
import { cleanImage } from '../../../utils/images.js';

moment.locale('it');

class App extends Component {
  componentDidMount() {
    //this.props.loadStore();
    //this.props.loadCategories();
    //this.props.loadCart();
    this.props.loadUser();

    // Se MailChimp ha passato la variabile mc_cid
    // in querystring, la metto nel localStorage.
    // Verrà passata nell'header McCid di tutte
    // le chiamate ad API
    const mcCid = this.props.router.location.query.mc_cid;
    if (mcCid) {
      localStorage.setItem('mc_cid', mcCid);
    }

    // Se AWIN ha passato la variabile awc
    // in querystring, la metto nel localStorage.
    // Verrà passata nell'header AwCks di tutte
    // le chiamate ad API
    const awCks = this.props.router.location.query.awc;
    if (awCks) {
      localStorage.setItem('aw_cks', awCks);
    }
  }

  renderBackgroundVersion = uiVariantBackground => {
    switch (uiVariantBackground) {
      case '1':
        return primary_s26_l96(this.props.primaryColor);
      case '2':
        return '#f6f6f6';
      case '3':
        return '#fff';
      // default:
      //   return primary_s26_l96(this.props.primaryColor);
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const isCheckout = this.props.router.isActive('checkout');
    return (
      <div className={isCheckout ? 'is-checkout' : 'is-not-checkout'}>
        <Helmet
          titleTemplate={`%s | ${this.props.siteName} - Ecommerce Farmacia`}
        >
          <link
            rel="icon"
            type="image/x-icon"
            href={cleanImage(this.props.favicon)}
          />
        </Helmet>
        <div
          className="global-wrapper"
          style={{
            backgroundColor: this.renderBackgroundVersion(
              this.props.uiVariantBackground
            ),
          }}
        >
          <Header isCheckout={isCheckout} />
          {this.props.children}
          <div className="push" />
        </div>
        <Footer isCheckout={isCheckout} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    storeId: state.store.data.storeId,
    siteName: state.store.data.datiFarmacia.siteName,
    favicon: state.store.data.loghiTemplate.faviconImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantBackground: state.store.data.uiVariants.background,
    products: state.products.data,
    state: state,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadCart: () => dispatch(loadCart()),
    loadUser: () => dispatch(loadUser()),
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDataFetchers(withRouter(App), [loadCategories, loadTags]));
